import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../../../utils/services/api.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class OrganizationAgencyResolverService implements Resolve<any> {

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let organizationID = route.params.id;
    let viewType = route.data.viewType;

    switch (viewType) {
      case 'ORGANIZATION':
        return this.apiService.getOrganizationAgency(organizationID).map((response) => {
          return response['data'].rows[0];
        }).catch((error) => {
          return Observable.of(null);
        });
      case 'AGENCY':
        return null;
    }

  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/organization-detail/resolvers/organization-agency-resolver.service.ts